export interface ObjectTypeType extends Record<string, string> {
  key: string;
  urlSubString: string;
  urlActionSummarySubString: string;
}

const ObjectType: Record<number, ObjectTypeType> = {
  4: { key: 'Equipment', urlSubString: 'lifting', urlActionSummarySubString: 'liftingActionSummaryDetails' },
  6: { key: 'Installation', urlSubString: 'electrical', urlActionSummarySubString: 'electricalActionSummaryDetails' },
};

export enum ObjectTypeEnum {
  EQUIPMENT = "EQUIPMENT",
  INSTALLATION = "INSTALLATION"
}

export const getObjectTypeByKey = (key: string): ObjectTypeType | undefined =>
  Object.values(ObjectType).find(objectType => objectType.key.toLowerCase() === key.toLowerCase());

export default ObjectType;
